import React from 'react'
import { Redirect } from 'react-router-dom'

import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import CampaignDashboard from '@/app/module/campaigns/component/item/dashboard'
import { type DashboardTab } from '@/app/module/campaigns/component/item/dashboard/types'
import Notifications from '@/app/module/notifications'
import { type MatchProps } from '@/app/types'

type Props = {
  match: MatchProps<{
    campId: string
    tabName?: string
  }>
}

export const resolveDashboardTab = (tabName?: string): DashboardTab => {
  switch (tabName) {
    case 'analytics':
      return 'analytics'
    case 'subscriptions':
      return 'subscriptions'
    default:
      return 'overview'
  }
}

const CampaignsDashboardPage: React.FC<Props> = ({ match }) => {
  const { campId, tabName } = match.params
  const activeTab = resolveDashboardTab(tabName)

  if (tabName && tabName !== activeTab) {
    return <Redirect to={`/campaigns/${campId}`} />
  }

  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout disableScrolling title="Campaign Dashboard - engageSPARK">
        <AuthHeader currentPage={PAGE.CAMPAIGNS.INDEX} />
        <TotpGuard>
          <CampaignDashboard itemId={campId} tabName={activeTab} />
        </TotpGuard>
        <Notifications />
      </Layout>
    </AuthGuard>
  )
}

export default CampaignsDashboardPage
